import { ApiService } from './apiService';
import { API_ENDPOINTS } from '../config/api';
import { parseDueDateFromApi } from '../utils/taskDate';
import { CreateUserTaskPayload, UserTaskCard } from '../types/userTask';
import type { TaskStatus } from '../types/kanban';

export const USER_TASK_STATUS_LABEL: Record<TaskStatus, string> = {
  un_assigned: 'UNASSIGNED',
  todo: 'TO DO',
  waiting_for_info: 'WAITING FOR INFO',
  in_progress: 'IN PROGRESS',
  completed: 'COMPLETED',
};

export const formatUserTaskDueDate = (apiDate: string | null | undefined): string => {
  const iso = parseDueDateFromApi(apiDate);
  if (!iso) return '—';
  const date = new Date(iso);
  if (Number.isNaN(date.getTime())) return apiDate ?? '—';
  return new Intl.DateTimeFormat('en-GB', {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
  }).format(date);
};

export const formatUserTaskPriority = (
  priority: string | null | undefined
): { label: string; cssKey: string } => {
  if (!priority) return { label: 'NORMAL', cssKey: 'normal' };
  const key = priority === 'medium' ? 'normal' : priority;
  return {
    label: key.toUpperCase(),
    cssKey: key,
  };
};

export const userTaskStatusCssKey = (status: TaskStatus): string => {
  if (status === 'waiting_for_info') return 'waiting-for-info';
  return status.replace(/_/g, '-');
};

export const userTaskSubtitle = (task: UserTaskCard): string => {
  if (task.labels.length > 0) return task.labels.map((l) => l.name).join(', ');
  if (task.type?.name) return task.type.name;
  return task.email;
};

export class UserTasksService extends ApiService {
  async listTasks(clientUserId: string): Promise<UserTaskCard[]> {
    return this.get<UserTaskCard[]>(API_ENDPOINTS.users.tasks(clientUserId));
  }

  async createTask(
    clientUserId: string,
    body?: CreateUserTaskPayload
  ): Promise<UserTaskCard> {
    return this.post<UserTaskCard>(API_ENDPOINTS.users.tasks(clientUserId), body);
  }
}

export const userTasksService = new UserTasksService();
